import { APIMetaInformation } from 'libs/end-to-end/src/api-meta-information';
import { getApiBaseUrl } from 'apps/sigma2-ui/src/constants/environment';
import React, { createContext, useCallback, useContext, useMemo } from 'react';
import { useSimpleReadPattern } from 'apps/sigma2-ui/src/lib/hooks/useSimpleReadPattern';

interface APIMetaInformationContext {
  metaInformation: APIMetaInformation | null;
}

const APIMetaInformationContext = createContext<APIMetaInformationContext>({
  metaInformation: null,
});

interface APIMetaInformationRendererProps {
  children: React.ReactNode;
}

export interface APIMetaInformationHook {
  metaInformation: APIMetaInformation | null;
}

export const useAPIMetaInformation = (): APIMetaInformationHook => {
  const context = useContext(APIMetaInformationContext);

  return useMemo(() => {
    return {
      metaInformation: context.metaInformation,
    };
  }, [context.metaInformation]);
};

export const APIMetaInformationRenderer = ({
  children,
}: APIMetaInformationRendererProps) => {
  const metaReadPattern = useSimpleReadPattern({
    getUrlFn: useCallback(() => `${getApiBaseUrl()}/info`, []),
    canRead: true,
    responseSchema: APIMetaInformation,
  });
  const value = useMemo(
    () => ({
      metaInformation:
        metaReadPattern.status === 'done' ? metaReadPattern.entity : null,
    }),
    [metaReadPattern],
  );

  return (
    <APIMetaInformationContext.Provider value={value}>
      {children}
    </APIMetaInformationContext.Provider>
  );
};
